import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

interface LetContext<T> {
  shrdUtcLet: T;
}

@Directive({
  selector: '[shrdUtcLet]'
})
export class LetDirective<T> {
  private readonly context: LetContext<T> = { shrdUtcLet: null };

  constructor(viewContainer: ViewContainerRef, templateRef: TemplateRef<LetContext<T>>) {
    viewContainer.createEmbeddedView(templateRef, this.context);
  }

  @Input()
  set shrdUtcLet(value: T) {
    this.context.shrdUtcLet = value;
  }
}
